import { render, staticRenderFns } from "./FundsDialog.vue?vue&type=template&id=2bd5fcf6&"
import script from "./FundsDialog.vue?vue&type=script&lang=js&"
export * from "./FundsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports